import React from 'react';
import { useIntl } from 'react-intl';

import Empty from '@/components/Empty/Empty';
import EmptyEmail from '@/components/Svg/Empty/EmptyEmail';

interface Props {
  text: string;
}

const EmptyCheckMail: React.FC<Props> = ({ text }) => {
  const intl = useIntl();
  return (
    <Empty
      icon={<EmptyEmail />}
      message={intl.formatMessage({ id: 'app.recoverpassword.sendmail.title' })}
      description={<p>{text}</p>}
    />
  );
};

export default EmptyCheckMail;
